/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'chat.bsky.notification.defs'

export { $nsid }

type Preferences = {
  $type?: 'chat.bsky.notification.defs#preferences'
  chat: ChatPreference
  chatRequest: ChatPreference
}

export type { Preferences }

const preferences = /*#__PURE__*/ l.typedObject<Preferences>(
  $nsid,
  'preferences',
  /*#__PURE__*/ l.object({
    chat: /*#__PURE__*/ l.ref<ChatPreference>((() => chatPreference) as any),
    chatRequest: /*#__PURE__*/ l.ref<ChatPreference>(
      (() => chatPreference) as any,
    ),
  }),
)

export { preferences }

type ChatPreference = {
  $type?: 'chat.bsky.notification.defs#chatPreference'
  include: 'all' | 'follows' | l.UnknownString
  push: boolean
}

export type { ChatPreference }

const chatPreference = /*#__PURE__*/ l.typedObject<ChatPreference>(
  $nsid,
  'chatPreference',
  /*#__PURE__*/ l.object({
    include: /*#__PURE__*/ l.string<{ knownValues: ['all', 'follows'] }>(),
    push: /*#__PURE__*/ l.boolean(),
  }),
)

export { chatPreference }
